<style scoped lang="scss">
    .tournament__participation__item{
        position: relative;

    }
    .disable-wrap{
        position: absolute;
        height: 100%;
        width: 100%;
        background: #0000004a;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        >p{
            width: fit-content;

            font-size: 1.4rem;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            margin: auto;
            height: fit-content;
            color: #000000;
        }
    }
</style>
<template>
    <div class="tournament__participation__item">
        <div class="tournament__participation__item__title float-content">
            <p class="item-title fl" :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-06.svg')}')`}">참가자2</p>
        </div>
        <!--본인이 아닐경우-->
        <div class="form-control-select-wrap">
            <div class="form-control-select">
                <p class="input-title">소속 </p>
                <select class="form-control-select" v-model="selectClub" @change="selectClubChangeFunc">
                    <option :value="null">소속선택</option>
                    <option v-if="clubs" v-for="club in clubs.clubList" :key="club.clubId" :value="club">{{club.clubName}}</option>
                </select>
            </div>
            <div class="form-control-search-wrap">
                <p class="input-title">이름</p>
                <div class="form-control-search">
                    <input class="form-control-select" placeholder="입력해주세요" v-model="nameKeyword"
                           v-on:keyup.enter="searchPlayerFunc()">
                    <span @click="searchPlayerFunc()"/>
                </div>
                <div class="name__search__result" v-show="isSearch" v-if="players">
                    <div class="name__search__result__content">
                        <div class="user-list float-content" @click="getPlayer(player)" v-for="player in players.playerList" :key="player.playerId">
                            <p class="name">{{player.playerName}}({{player.playerId}})</p>
                            <p class="affiliation">{{player.clubName}}({{player.clubId}})</p>
                        </div>
                        <div class="float-content" v-if="players.playerList.length === 0">
                            <p class="name" style="width: 100%">검색결과가 없습니다</p>
                        </div>
                    </div>
                </div>
            </div>




        </div>
        <div class="disable-wrap" v-if="!checkFirstPlayer">
            <p>사용자 1 선택 후 선택이 가능합니다</p>
        </div>
        <AlertModal v-show="emptyClubAlertShow" content="소속을 먼저 선택해주세요" @close="emptyClubAlertShow=false"></AlertModal>
        <AlertModal v-show="emptyPlayerNameAlertShow" content="검색할 이름을 먼저 입력해주세요" @close="emptyPlayerNameAlertShow"></AlertModal>
    </div>
</template>

<script>
    import participantFormMixin from "../../../mixins/participantFormMixin";

    export  default{
        mixins: [participantFormMixin],
        props: ['check_first_player'],
        data(){
            return{
                checkFirstPlayer: this.check_first_player
            }
        },
        watch: {
            check_first_player: function(newVal){
                this.checkFirstPlayer = newVal
            }

        },
        methods:{

            searchPlayerFunc() {

                if (!this.selectClub) {
                    this.emptyClubAlertShow = true
                } else if (!this.nameKeyword) {
                    this.emptyPlayerNameAlertShow = true
                } else {
                    const temp = {
                        tnmtId: this.$route.params.tnmtId,
                        clubId: this.selectClub.clubId,
                        playerNameKey: this.nameKeyword
                    }
                    const _this = this
                    this.$store.dispatch('participants/getClubPlayerList', temp).then(res => {
                        _this.isSearch = true
                    })
                }
            },

            getPlayer(player) {
                this.selectPlayer = player
                this.isSearch = false
                const temp = {
                    userId: player.playerId,
                    type: 'P'
                }


                this.$emit('input', temp)
            },
        }
    }
</script>
